import useAsyncEffect from 'shared/hooks/use-async-effect'
import { ICustomFont } from 'site/creation-tools/components/supercut/shared/types'
import styled from 'styled-components'
import CreationToolFont from '../../../../types/font'
import { preloadFont } from '../../../../utils/preload'
import SelectListComponent from '../../../select-list'
import { SourceEditorCaptionStyle } from '../../types'

const BASE_FONT_SIZE = 18

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

type Props = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (style: SourceEditorCaptionStyle) => void
    customFont?: ICustomFont
}

const CreationSourceEditorCaptionFontDropdown = ({ captionStyle, setCaptionStyle, customFont }: Props) => {
    const fonts = CreationToolFont.all(customFont != undefined)

    useAsyncEffect(async () => {
        if (!customFont) return

        try {
            // if custom font provided, load font with font family name
            await preloadFont(customFont.fontUrl, CreationToolFont.fontFamily(CreationToolFont.Custom))
        } catch (e) {
            console.log(e)
        }
    }, [customFont])

    const onChange = (font: CreationToolFont) => {
        setCaptionStyle({
            ...captionStyle,
            font,
        })
    }

    return (
        <SelectList
            {...{
                onChange,
                value: captionStyle.font,
                options: fonts.map((font) => ({
                    value: font,
                    label: (
                        <span
                            key={font}
                            style={{
                                fontFamily: CreationToolFont.fontFamily(font),
                                fontSize: `${Math.round(BASE_FONT_SIZE * CreationToolFont.scale(font))}px`,
                                fontWeight: CreationToolFont.fontWeight(font),
                                textTransform: CreationToolFont.isAllCaps(font) ? 'uppercase' : 'none',
                            }}
                        >
                            {CreationToolFont.title(font)}
                        </span>
                    ),
                })),
            }}
        />
    )
}

export default CreationSourceEditorCaptionFontDropdown
